<!-- @format -->

<ng-container *transloco="let t">
  @if (showLoginOptions$ | async) {
    <main class="student-login-page" role="main">
      <fudis-heading [level]="1">{{ t("STUDENT_LOGIN_PAGE.TITLE") }}</fudis-heading>
      @if (universityName$ | async; as universityName) {
        <fudis-body-text [variant]="'lg-regular'">{{ universityName }}</fudis-body-text>
      }

      <section class="student-login-box" [attr.aria-label]="t('STUDENT_LOGIN_PAGE.STUDENT_SECTION_TITLE')">
        <fudis-heading [level]="2" [align]="'center'">{{ t("STUDENT_LOGIN_PAGE.STUDENT_SECTION_TITLE") }}</fudis-heading>
        <div class="student-login-box__buttons">
          @if (logins.length === 1) {
            <fudis-button
              [label]="t('STUDENT_LOGIN_PAGE.IDP_LOGIN_BUTTON_GENERIC')"
              (handleClick)="selectIdp(logins[0])"
              data-cy="sisu-login-button" />
          } @else {
            @for (login of logins; track $index) {
              <fudis-button [label]="login.name | localizedString" (handleClick)="selectIdp(login)" data-cy="sisu-login-button" />
            }
          }
        </div>
      </section>

      <fudis-heading [level]="2" class="student-login-page__other-options-title">{{
        t("STUDENT_LOGIN_PAGE.OTHER_OPTIONS_TITLE")
      }}</fudis-heading>

      <div class="student-login-page__expandables">
        <fudis-expandable [title]="t('STUDENT_LOGIN_PAGE.BROWSE_WITHOUT_LOGIN_TITLE')" [level]="3" [variant]="'lite'" [closed]="true">
          <ng-template fudisExpandableContent>
            <fudis-body-text class="fudis-mb-md">{{ t("STUDENT_LOGIN_PAGE.BROWSE_WITHOUT_LOGIN_DESCRIPTION") }}</fudis-body-text>
            <fudis-button
              [label]="t('STUDENT_LOGIN_PAGE.BROWSE_WITHOUT_LOGIN_BUTTON')"
              [variant]="'secondary'"
              (handleClick)="navigateWithoutLogin()" />
          </ng-template>
        </fudis-expandable>

        @if (suomiFiLoginEnabled$ | async) {
          <fudis-expandable [title]="t('STUDENT_LOGIN_PAGE.GRADUATED_TITLE')" [level]="3" [variant]="'lite'" [closed]="true">
            <ng-template fudisExpandableContent>
              <fudis-body-text class="fudis-mb-md">{{ t("STUDENT_LOGIN_PAGE.GRADUATED_DESCRIPTION") }}</fudis-body-text>
              <fudis-button [label]="t('STUDENT_LOGIN_PAGE.GRADUATED_BUTTON')" [variant]="'secondary'" (handleClick)="loginWithSuomiFi()" />
            </ng-template>
          </fudis-expandable>
        }
      </div>
    </main>
  }
</ng-container>
